/* =====================================================================
   PB UI (v0.1) — fælles UI-komponenter.
   [data-pb-row]: produktrækker med indbygget scroll-bar (tynd gul "thumb" der viser
   hvor man er), pile på desktop, træk med musen (glider til nærmeste kort ved slip),
   swipe på touch. Skjuler sig selv når alt kan ses. Ingen browser-scrollbar.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, PB = window.PB;
  if (!PB) return;

  function initRow(root) {
    if (root.__pbRow) return; root.__pbRow = 1;
    var track = root.querySelector('[data-pb-row-track]'), bar = root.querySelector('[data-pb-row-bar]');
    var thumb = root.querySelector('[data-pb-row-thumb]'), tbar = root.querySelector('[data-pb-row-trackbar]');
    var prev = root.querySelector('[data-pb-row-prev]'), next = root.querySelector('[data-pb-row-next]');
    if (!track || !bar) return;

    function step() { var li = track.firstElementChild; if (!li) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap) || 0; var per = Math.max(1, Math.round((track.clientWidth + gap) / (li.getBoundingClientRect().width + gap))); return per * (li.getBoundingClientRect().width + gap); }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      bar.hidden = max <= 4;
      if (max <= 4) return;
      var vis = track.clientWidth / track.scrollWidth, pos = track.scrollLeft / max;
      var tw = tbar.clientWidth, w = Math.max(28, tw * vis);
      thumb.style.width = w + 'px';
      thumb.style.transform = 'translateX(' + ((tw - w) * pos) + 'px)';
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(track); else window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    /* klik på sporet = hop dertil */
    tbar.addEventListener('click', function (e) { var r = tbar.getBoundingClientRect(), f = (e.clientX - r.left) / r.width; track.scrollTo({ left: f * (track.scrollWidth - track.clientWidth), behavior: 'smooth' }); });

    /* træk med musen */
    var drag = null, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, sl: track.scrollLeft, id: e.pointerId }; moved = false;
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!moved) { if (Math.abs(dx) < 6) return; moved = true; track.classList.add('is-drag'); try { track.setPointerCapture(e.pointerId); } catch (x) {} }
      track.scrollLeft = drag.sl - dx;
    });
    function end() {
      if (!drag) return; drag = null;
      if (!moved) return;
      /* glid til nærmeste kort — snap holdes slået fra til glidet er færdigt (ellers "svinger" rækken tilbage først) */
      var li = track.firstElementChild; if (!li) { track.classList.remove('is-drag'); return; }
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0, w = li.getBoundingClientRect().width + gap;
      track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' });
      var done = false, fin = function () { if (done) return; done = true; track.classList.remove('is-drag'); track.removeEventListener('scrollend', fin); };
      track.addEventListener('scrollend', fin); setTimeout(fin, 700);
      setTimeout(function () { moved = false; }, 0);
    }
    track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end); track.addEventListener('lostpointercapture', end);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    update();
  }
  function scan() { Array.prototype.forEach.call(d.querySelectorAll('[data-pb-row]'), initRow); }
  PB.rows = { scan: scan };   /* rækker, der sættes ind senere (anbefalinger, senest set) */
  /* gave-ikonet i headeren: mus over → nedtællingen kommer op over ikonerne (fra gaven og mod højre) */
  function gwChip() {
    Array.prototype.forEach.call(d.querySelectorAll('[data-pb-gwico]'), function (el) {
      var pop = el.querySelector('.pb-gwpop'), out = el.querySelector('[data-pb-gwcount]'), grp = el.closest('.pb-header__icons');
      var iso = el.getAttribute('data-draw') || el.getAttribute('data-end') || '';
      var end = new Date(iso.replace(/([+-]\d{2})(\d{2})$/, '$1:$2')).getTime(), tm = null;
      var L = { d: PB.t('gw_d') || 'd', h: PB.t('gw_h') || 't' };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function upd() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        out.textContent = Math.floor(s / 86400) + L.d + ' ' + pad(Math.floor(s % 86400 / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      }
      function size() { if (grp && pop) { var a = el.getBoundingClientRect(), b = grp.getBoundingClientRect(); if (b.right > a.left) pop.style.setProperty('--gwpw', Math.round(b.right - a.left + 2) + 'px'); } }
      if (isNaN(end) || !out) return;
      upd(); size();
      window.addEventListener('resize', size, { passive: true });
      el.addEventListener('mouseenter', function () { size(); upd(); clearInterval(tm); tm = setInterval(upd, 1000); });
      el.addEventListener('mouseleave', function () { clearInterval(tm); });
      el.addEventListener('focus', function () { upd(); });
    });
  }
  PB.ready(gwChip);
  PB.ready(scan);
  d.addEventListener('shopify:section:load', scan);
})();
